var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","top":"4rem","right":"0.5rem"},attrs:{"aria-atomic":"true"}},_vm._l((_vm.items),function(item){return _c('ToastMessage',{key:item.id,attrs:{"item":item,"id":'message-id-' + item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }